import React from 'react'

function BRTagnProperties() {
  return (
    <div>
      <h5>Brake Line has Zero Properties!</h5>
    </div>
  )
}

export default BRTagnProperties
